import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function ChecklistsIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Ellipse 91" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M0.969439 9.22014C0.652968 10.4752 0.276868 13.2498 3.00154 13.2498l7.11446 0c-1.9531 0 -2.77394 -2.1704 -2.038 -4.02966 -2.3892 -0.28394 -4.71936 -0.28394 -7.108561 0Z"
          strokeWidth="1"></path>
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round" d="m6.31641 3.91431 2.53895 0"
          strokeWidth="1"></path>
    <path id="Vector_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round" d="m6.31641 6.57019 2.53895 0"
          strokeWidth="1"></path>
    <path id="Subtract" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M10.0533 13.249c2.4405 -0.0592 2.0983 -2.8825 1.7421 -5.82117 -0.3457 -2.85214 -0.7045 -5.81305 1.4545 -6.461509 -2.6415 -0.279997 -5.23046 -0.296737 -7.86894 0C2.68291 1.81197 3.59812 7.51961 3.9832 9.00909M9.97426 13.25c0.01233 0 0.02459 -0.0001 0.03674 -0.0002h-0.15374c0.03895 0.0001 0.07796 0.0002 0.117 0.0002Z"
          strokeWidth="1"></path>

  </SvgIcon>
}
